import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FaHeart } from 'react-icons/fa';

function Success() {
  return (
    <div className="container success-page">
      <Helmet>
        <title>Bestilling Bekreftet - HeroPixelLab</title>
        <link href="https://heropixellab.com/success/" rel="canonical"/>
      </Helmet>
      <FaHeart className="success-icon" />
      <h1 className="success-title">Takk for din bestilling!</h1>
      <p className="success-message">
        Din bestilling er mottatt og behandles nå. Du vil snart motta en bekreftelse på e-post med alle detaljer om leveransen.
      </p>
      <Link to="/" className="detail-button add-to-cart">Tilbake til butikken</Link>
      <div className="page-number">Side 8</div>
    </div>
  );
}

export default Success;